// extracted by mini-css-extract-plugin
export default {"maindiv":"Pagination_maindiv__CFaZo"};